<it-card teaser="true" shadow="true" *ngIf="noteTypes?.length">
  <div class="row mt-2">
    <div class="col">
      <div class="mb-3">
        <it-select
          label="Tipologia Nota"
          [(ngModel)]="selectedTypeNoteId"
        >
          <option [value]="null">Seleziona la tipologia della nota</option>
          <option *ngFor="let type of noteTypes" [value]="type.id">
            {{ type.name }}
          </option>
        </it-select>
      </div>
    
      <div class="mb-3">
        <it-textarea label="Testo della nota" description="Inserire testo" [rows]="10" [(ngModel)]="text"></it-textarea>
      </div>
    
      <div class="d-flex justify-content-end gap-2 mt-4">
        <button itButton="outline-primary" type="button" (click)="cancel()">
          Torna indietro
        </button>
        <button
          itButton="primary"
          type="button"
          [disabled]="!selectedTypeNoteId || !text"
          (click)="confirm()"
        >
          Inserisci nota
        </button>
      </div>
    </div>
  </div>    
  </it-card>
  